export default {
      id: "video-event_accident-usage",
      viewBox: "0 0 33 20",
      url: __webpack_public_path__ + "img/icons.svg#video-event_accident",
      toString: function () {
        return this.url;
      }
    }